var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-toolbar-wrapper" },
    [
      _c("div", { staticClass: "board-view-tabs" }, [
        _c("div", { staticClass: "tabs-container" }, [
          _c(
            "div",
            { staticClass: "left" },
            [
              _c(
                "div",
                {
                  staticClass: "tab",
                  class: { active: _vm.currentBoardView === "table" },
                  on: {
                    click: function ($event) {
                      return _vm.changeBoardView("table")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("grid_on"),
                  ]),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("tables.table")) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab",
                  class: { active: _vm.currentBoardView === "kanban" },
                  on: {
                    click: function ($event) {
                      return _vm.changeBoardView("kanban")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("view_kanban"),
                  ]),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("tables.kanban")) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab",
                  class: { active: _vm.currentBoardView === "calendar" },
                  on: {
                    click: function ($event) {
                      return _vm.changeBoardView("calendar")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("event")]),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("tables.calendar")) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.customPages, function (page) {
                return _c(
                  "div",
                  {
                    key: page._id,
                    staticClass: "tab",
                    class: { active: _vm.currentBoardView === page._id },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "tab-content",
                        on: {
                          click: function ($event) {
                            return _vm.changeBoardView(page._id)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("dashboard"),
                        ]),
                        _vm._v(
                          "\n                        " +
                            _vm._s(page.name) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.currentBoardView === page._id
                      ? _c(
                          "a-dropdown",
                          [
                            _c(
                              "a-button",
                              { staticClass: "page-actions-btn" },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("more_vert"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-menu",
                              {
                                staticClass: "page-actions-menu",
                                attrs: { slot: "overlay" },
                                slot: "overlay",
                              },
                              [
                                _c(
                                  "PermissionController",
                                  { attrs: { permissions: ["table.update"] } },
                                  [
                                    _c(
                                      "a-menu-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.duplicatePage(page)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("content_copy")]
                                        ),
                                        _vm._v(
                                          "\n                                    Sayfayı Çoğalt\n                                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "PermissionController",
                                  { attrs: { permissions: ["table.update"] } },
                                  [
                                    _c(
                                      "a-menu-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.showRenamePageModal(page)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("edit")]
                                        ),
                                        _vm._v(
                                          "\n                                    Sayfayı Yeniden Adlandır\n                                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "PermissionController",
                                  { attrs: { permissions: ["table.update"] } },
                                  [
                                    _c(
                                      "a-menu-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.confirmDeletePage(page)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "i",
                                          {
                                            staticClass: "material-icons",
                                            staticStyle: { color: "#ff4d4f" },
                                          },
                                          [_vm._v("delete")]
                                        ),
                                        _vm._v(
                                          "\n                                    Sayfayı Sil\n                                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "PermissionController",
                { attrs: { permissions: ["table.update"] } },
                [
                  _c(
                    "a-popover",
                    { attrs: { placement: "bottom", trigger: "click" } },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c("div", { staticClass: "template-list" }, [
                            _c(
                              "div",
                              {
                                staticClass: "template-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.onCreateNewTablePage("blank")
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("insert_drive_file"),
                                ]),
                                _vm._v(
                                  "\n                                    Blank\n                                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "template-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.onCreateNewTablePage("chart")
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("insert_chart"),
                                ]),
                                _vm._v(
                                  "\n                                    Chart\n                                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "template-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.onCreateNewTablePage("form")
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("assignment"),
                                ]),
                                _vm._v(
                                  "\n                                    Form\n                                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "template-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.onCreateNewTablePage("gantt")
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("view_timeline"),
                                ]),
                                _vm._v(
                                  "\n                                    Gantt\n                                "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "tab add-view" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("add"),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _vm._v(" "),
          _vm.moduleMode && _vm.selectedModule
            ? _c("div", { staticClass: "right" }, [
                _c("div", { staticClass: "module-title-wrapper" }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v(_vm._s(_vm.selectedModule.icon || "extension")),
                  ]),
                  _vm._v(" "),
                  _c("h3", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.selectedModule.displayName)),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-toolbar" },
        [
          _c(
            "div",
            { staticClass: "left-actions" },
            [
              _c(
                "a-popover",
                {
                  attrs: {
                    placement: "bottomLeft",
                    trigger: "click",
                    overlayClassName: "view-switcher-popover zero-padding",
                  },
                  model: {
                    value: _vm.viewSwitcherVisible,
                    callback: function ($$v) {
                      _vm.viewSwitcherVisible = $$v
                    },
                    expression: "viewSwitcherVisible",
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "content" },
                    [
                      _c("ViewSwitcher", {
                        attrs: {
                          table: _vm.table,
                          "selected-view-id": _vm.$_.get(
                            _vm.currentView,
                            "_id"
                          ),
                        },
                        on: {
                          "show-view": _vm.onShowView,
                          "edit-view": _vm.onEditView,
                          "create-new-view": _vm.onCreateNewView,
                          "view-deleted": _vm.onViewDeleted,
                          "view-duplicated": _vm.onViewDuplicated,
                          "view-updated": _vm.onViewUpdated,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("SupsisButton", { attrs: { primary: "" } }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.currentView
                            ? _vm.currentView.name
                            : _vm.$t("tables.mainTable") +
                                " - (" +
                                _vm.table.name +
                                ")"
                        ) +
                        "\n                    "
                    ),
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("arrow_drop_down"),
                    ]),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "a-popover",
                {
                  attrs: {
                    placement: "bottomLeft",
                    trigger: "click",
                    visible: _vm.filterVisible,
                    overlayClassName: "table-filter-popover",
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "content" },
                    [
                      _c("TableFilter", {
                        attrs: {
                          fields: _vm.fields,
                          value: _vm.filters,
                          records: _vm.records,
                        },
                        on: {
                          input: _vm.onFilterChange,
                          close: function ($event) {
                            _vm.filterVisible = false
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      attrs: {
                        classNames:
                          "" + (_vm.filters.length > 0 ? "active-filters" : ""),
                      },
                      on: {
                        click: function ($event) {
                          _vm.filterVisible = !_vm.filterVisible
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("filter_alt"),
                      ]),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("tables.filter")) +
                          "\n                    "
                      ),
                      _vm.filters.length > 0
                        ? _c("span", { staticClass: "filter-count" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.filters.length) +
                                "\n                    "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.filters.length
                        ? _c(
                            "i",
                            {
                              staticClass: "material-icons clear-filters",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.clearFilters.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v("close")]
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                2
              ),
              _vm._v(" "),
              !_vm.moduleMode
                ? _c(
                    "SupsisButton",
                    {
                      attrs: {
                        classNames:
                          "" +
                          (_vm.hiddenFields.length > 0 ? "active-filters" : ""),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("show-hide-fields")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("visibility_off"),
                      ]),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("tables.hideFields")) +
                          "\n                "
                      ),
                      _vm.hiddenFields.length > 0
                        ? _c("span", { staticClass: "filter-count" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.hiddenFields.length) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hiddenFields.length > 0
                        ? _c(
                            "i",
                            {
                              staticClass: "material-icons clear-filters",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.$emit("clear-hidden-fields")
                                },
                              },
                            },
                            [_vm._v("close")]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a-popover",
                {
                  attrs: {
                    placement: "bottomRight",
                    trigger: "click",
                    overlayClassName: "table-group-popover",
                  },
                  model: {
                    value: _vm.groupPopoverVisible,
                    callback: function ($$v) {
                      _vm.groupPopoverVisible = $$v
                    },
                    expression: "groupPopoverVisible",
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "content" },
                    [
                      _c("TableGroup", {
                        attrs: {
                          fields: _vm.fields,
                          "group-value": _vm.groupValue,
                        },
                        on: { "update-group": _vm.onUpdateGroup },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      attrs: {
                        classNames:
                          "" + (_vm.groupValue.fieldId ? "active-filters" : ""),
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("category"),
                      ]),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("message.group")) +
                          "\n                    "
                      ),
                      _vm.groupValue.fieldId
                        ? _c("span", { staticClass: "filter-count" }, [
                            _vm._v(" 1 "),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "a-popover",
                {
                  attrs: {
                    placement: "bottomRight",
                    trigger: "click",
                    overlayClassName: "table-color-popover",
                  },
                  model: {
                    value: _vm.colorPopoverVisible,
                    callback: function ($$v) {
                      _vm.colorPopoverVisible = $$v
                    },
                    expression: "colorPopoverVisible",
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "content" },
                    [
                      _c("TableColorFilter", {
                        attrs: {
                          fields: _vm.fields,
                          "color-conditions": _vm.colorConditions,
                        },
                        on: {
                          "update-color-conditions":
                            _vm.onUpdateColorConditions,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      attrs: {
                        classNames:
                          "" +
                          (_vm.colorConditions.length > 0
                            ? "active-filters"
                            : ""),
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("color_lens"),
                      ]),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("tables.conditionalColor")) +
                          "\n                    "
                      ),
                      _vm.colorConditions.length > 0
                        ? _c("span", { staticClass: "filter-count" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.colorConditions.length) +
                                "\n                    "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "PermissionController",
                { attrs: { permissions: ["table.update"] } },
                [
                  !_vm.moduleMode
                    ? _c(
                        "SupsisButton",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.$feature.beforeCreateTableView(
                                _vm.openCreateViewModal,
                                _vm.table.totalViews
                              )
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("save"),
                          ]),
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("tables.saveAsView")) +
                              "\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "right-actions" },
            [
              _c(
                "div",
                {
                  staticClass: "search-bar",
                  class: { expanded: _vm.searchExpanded || _vm.searchQuery },
                  on: {
                    click: function ($event) {
                      _vm.searchExpanded = true
                    },
                  },
                },
                [
                  _c("input", {
                    ref: "searchInput",
                    attrs: {
                      type: "text",
                      placeholder: _vm.$t("tables.search"),
                      autofocus: "",
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.onSearchEnter.apply(null, arguments)
                      },
                      focus: function ($event) {
                        _vm.searchExpanded = true
                      },
                      blur: function ($event) {
                        _vm.searchExpanded = false
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "i",
                    {
                      staticClass: "material-icons",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          _vm.searchExpanded = true
                        },
                      },
                    },
                    [_vm._v("search")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "PermissionController",
                { attrs: { permissions: ["table.update"] } },
                [
                  _vm.isRecordLimitExceeded
                    ? _c(
                        "a-tooltip",
                        { attrs: { placement: "bottom" } },
                        [
                          _c("template", { slot: "title" }, [
                            _vm._v(
                              "\n                        Kayıt limiti doldu. Yeni kayıt eklemek için plan yükseltmeniz gerekiyor.\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-badge",
                            {
                              attrs: {
                                count: _vm.isRecordLimitExceeded ? "!" : 0,
                                "number-style": { backgroundColor: "#ff4d4f" },
                              },
                            },
                            [
                              _vm.canCreateRecord
                                ? _c(
                                    "SupsisButton",
                                    {
                                      attrs: { primary: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$feature.beforeCreateTableRecord(
                                            _vm.openCreateRecordModal,
                                            _vm.total
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("add")]
                                      ),
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$t("message.createRecord")
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isRecordLimitExceeded && _vm.canCreateRecord
                    ? _c(
                        "SupsisButton",
                        {
                          attrs: { primary: "" },
                          on: {
                            click: function ($event) {
                              return _vm.$feature.beforeCreateTableRecord(
                                _vm.openCreateRecordModal,
                                _vm.total
                              )
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("add"),
                          ]),
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("message.createRecord")) +
                              "\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.moduleMode
                ? _c(
                    "a-popover",
                    { attrs: { trigger: "click", placement: "bottomRight" } },
                    [
                      _c("template", { slot: "content" }, [
                        _c(
                          "div",
                          { staticClass: "action-menu" },
                          [
                            _c(
                              "PermissionController",
                              { attrs: { permissions: ["automation.get"] } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "action-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleAction(
                                          "runWebhookAutomation"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "i",
                                      {
                                        staticClass: "material-icons",
                                        staticStyle: { color: "#1890ff" },
                                      },
                                      [_vm._v("webhook")]
                                    ),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t("tables.runWebhookAutomation")
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "PermissionController",
                              { attrs: { permissions: ["table.update"] } },
                              [
                                _vm.canImportRecords &&
                                _vm.isRecordLimitExceeded
                                  ? _c(
                                      "a-tooltip",
                                      { attrs: { placement: "left" } },
                                      [
                                        _c("template", { slot: "title" }, [
                                          _vm._v(
                                            "\n                                    Kayıt limiti doldu. Kayıt içeri aktarmak için plan yükseltmeniz gerekiyor.\n                                "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "action-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleAction(
                                                  "importRecords"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "i",
                                              {
                                                staticClass: "material-icons",
                                                staticStyle: {
                                                  color: "#52c41a",
                                                },
                                              },
                                              [_vm._v("upload_file")]
                                            ),
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t("tables.importRecords")
                                                ) +
                                                "\n                                    "
                                            ),
                                            _c("a-badge", {
                                              staticStyle: {
                                                "margin-left": "8px",
                                              },
                                              attrs: {
                                                dot: "",
                                                "number-style": {
                                                  backgroundColor: "#ff4d4f",
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.canImportRecords &&
                                !_vm.isRecordLimitExceeded
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "action-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleAction(
                                              "importRecords"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "i",
                                          {
                                            staticClass: "material-icons",
                                            staticStyle: { color: "#52c41a" },
                                          },
                                          [_vm._v("upload_file")]
                                        ),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$t("tables.importRecords")
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.canExportRecords
                              ? _c(
                                  "div",
                                  { staticClass: "action-item" },
                                  [
                                    _c(
                                      "a-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          placement: "left",
                                        },
                                      },
                                      [
                                        _c("template", { slot: "content" }, [
                                          _c(
                                            "div",
                                            { staticClass: "action-menu" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "action-item",
                                                  class: {
                                                    disabled: !_vm.hasSelection,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      _vm.hasSelection &&
                                                        _vm.downloadSelectedRecords()
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                      staticStyle: {
                                                        color: "#52c41a",
                                                      },
                                                    },
                                                    [_vm._v("check_box")]
                                                  ),
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        _vm.hasSelection
                                                          ? "Seçilenleri İndir (" +
                                                              _vm
                                                                .selectedRecords
                                                                .length +
                                                              ")"
                                                          : "Seçilenleri İndir"
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "action-item",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.openExport(
                                                        "page"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                      staticStyle: {
                                                        color: "#faad14",
                                                      },
                                                    },
                                                    [_vm._v("file_download")]
                                                  ),
                                                  _vm._v(
                                                    "\n                                            Bu Sayfayı İndir\n                                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "action-item",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.openExport(
                                                        "all"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                      staticStyle: {
                                                        color: "#faad14",
                                                      },
                                                    },
                                                    [_vm._v("cloud_download")]
                                                  ),
                                                  _vm._v(
                                                    "\n                                            Tümünü İndir\n                                        "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _c(
                                            "i",
                                            {
                                              staticClass: "material-icons",
                                              staticStyle: { color: "#faad14" },
                                            },
                                            [_vm._v("download")]
                                          ),
                                          _vm._v(
                                            "\n                                    Kayıtları İndir\n                                "
                                          ),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "PermissionController",
                              { attrs: { permissions: ["automation.get"] } },
                              [
                                _vm.canUpdateRecord
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "action-item",
                                        class: { disabled: !_vm.hasSelection },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleAction(
                                              "editRecords"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "i",
                                          {
                                            staticClass: "material-icons",
                                            staticStyle: { color: "#1890ff" },
                                          },
                                          [_vm._v("edit")]
                                        ),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.hasSelection
                                                ? _vm.$t("message.edit") +
                                                    " " +
                                                    _vm.selectedRecords.length +
                                                    " " +
                                                    _vm.$t("message.records")
                                                : _vm.$t("tables.editRecords")
                                            ) +
                                            "\n                                "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "shortcut" },
                                          [
                                            _c("kbd", [_vm._v("Ctrl")]),
                                            _vm._v("+"),
                                            _c("kbd", [_vm._v("E")]),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "PermissionController",
                              { attrs: { permissions: ["table.delete"] } },
                              [
                                _vm.canDeleteRecord
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "action-item",
                                        class: { disabled: !_vm.hasSelection },
                                        on: { click: _vm.confirmDeleteRecords },
                                      },
                                      [
                                        _c(
                                          "i",
                                          {
                                            staticClass: "material-icons",
                                            staticStyle: { color: "#ff4d4f" },
                                          },
                                          [_vm._v("delete")]
                                        ),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.hasSelection
                                                ? _vm.$t("message.delete") +
                                                    " " +
                                                    _vm.selectedRecords.length +
                                                    " " +
                                                    _vm.$t("message.records")
                                                : _vm.$t("tables.deleteRecords")
                                            ) +
                                            "\n                                "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "shortcut" },
                                          [_c("kbd", [_vm._v("Backspace")])]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "PermissionController",
                              { attrs: { permissions: ["table.update"] } },
                              [
                                _vm.canCreateRecord
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "action-item",
                                        class: { disabled: !_vm.hasSelection },
                                        on: {
                                          click: _vm.confirmDuplicateRecords,
                                        },
                                      },
                                      [
                                        _c(
                                          "i",
                                          {
                                            staticClass: "material-icons",
                                            staticStyle: { color: "#52c41a" },
                                          },
                                          [_vm._v("content_copy")]
                                        ),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.hasSelection
                                                ? _vm.$t("message.duplicate") +
                                                    " " +
                                                    _vm.selectedRecords.length +
                                                    " " +
                                                    _vm.$t("message.records")
                                                : _vm.$t(
                                                    "tables.duplicateRecords"
                                                  )
                                            ) +
                                            "\n                                "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "shortcut" },
                                          [
                                            _c("kbd", [_vm._v("Ctrl")]),
                                            _vm._v("+"),
                                            _c("kbd", [_vm._v("D")]),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "action-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAction(
                                      "toggleZebraStripes"
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "i",
                                  {
                                    staticClass: "material-icons",
                                    staticStyle: { color: "#9254de" },
                                  },
                                  [_vm._v("view_agenda")]
                                ),
                                _vm._v(
                                  "\n                            Zebra Mod\n                            "
                                ),
                                _c("a-switch", {
                                  staticClass: "zebra-switch",
                                  attrs: {
                                    size: "small",
                                    checked: _vm.zebraStripes,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.canShowPermissionSettings
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "action-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleAction(
                                          "privacySettings"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "i",
                                      {
                                        staticClass: "material-icons",
                                        staticStyle: { color: "#722ed1" },
                                      },
                                      [_vm._v("admin_panel_settings")]
                                    ),
                                    _vm._v(
                                      "\n                            Gizlilik Ayarları\n                        "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("SupsisButton", [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("more_horiz"),
                        ]),
                      ]),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showCreateViewModal
                ? _c(
                    "Modal2",
                    {
                      attrs: {
                        showFooter: false,
                        title: _vm.$t("tables.saveAsView"),
                        className: "create-view-modal keydown-prevent-modal",
                      },
                      on: { cancel: _vm.closeCreateViewModal },
                    },
                    [
                      _c("CreateViewForm", {
                        attrs: {
                          filters: _vm.filters,
                          sort: _vm.sort,
                          search: _vm.searchQuery,
                          hiddenFields: _vm.hiddenFields,
                          lockedFields: _vm.lockedFields,
                          "table-id": _vm.tableId,
                          "group-value": _vm.groupValue,
                          "color-conditions": _vm.colorConditions,
                        },
                        on: {
                          "view-created": _vm.onViewCreated,
                          cancel: _vm.closeCreateViewModal,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.showCreateRecordModal
            ? _c(
                "Modal2",
                {
                  attrs: {
                    showFooter: false,
                    title: "Yeni Kayıt Oluştur",
                    className: "create-record-modal keydown-prevent-modal",
                  },
                  on: { cancel: _vm.closeCreateRecordModal },
                },
                [
                  _c("TableCreateRecordForm", {
                    attrs: {
                      table: _vm.table,
                      predefinedValues: _vm.predefinedValues,
                      "default-linked-record-cache":
                        _vm.defaultLinkedRecordCache,
                    },
                    on: { "record-created": _vm.onRecordCreated },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showCreatePageModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Yeni Sayfa Oluştur",
                okText: "Oluştur",
                cancelText: "İptal",
                showFooter: true,
              },
              on: {
                cancel: _vm.closeCreatePageModal,
                ok: _vm.handleCreatePage,
              },
            },
            [
              _c(
                "a-form",
                { attrs: { form: _vm.createPageForm, layout: "vertical" } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "Sayfa Adı" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "name",
                              {
                                rules: [
                                  {
                                    required: true,
                                    message: "Lütfen sayfa adı girin",
                                  },
                                ],
                              },
                            ],
                            expression:
                              "[\n                        'name',\n                        {\n                            rules: [{ required: true, message: 'Lütfen sayfa adı girin' }],\n                        },\n                    ]",
                          },
                        ],
                        attrs: { placeholder: "Sayfa adı girin" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: "Açıklama" } },
                    [
                      _c("a-textarea", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["description"],
                            expression: "['description']",
                          },
                        ],
                        attrs: {
                          rows: 4,
                          placeholder: "Sayfa açıklaması girin",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showRenameModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Sayfayı Yeniden Adlandır",
                confirmLoading: _vm.renamingPage,
                okText: "Kaydet",
                cancelText: "İptal",
              },
              on: { cancel: _vm.closeRenameModal, ok: _vm.handleRename },
            },
            [
              _c(
                "a-form-item",
                { attrs: { label: "Sayfa Adı" } },
                [
                  _c("a-input", {
                    attrs: { placeholder: "Sayfa adı girin" },
                    model: {
                      value: _vm.newPageName,
                      callback: function ($$v) {
                        _vm.newPageName = $$v
                      },
                      expression: "newPageName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showExportSettings
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("Kayıtları İndir - Ayarlar"),
                className: "export-settings-modal keydown-prevent-modal",
                showFooter: false,
                xlarge: "",
              },
              on: { cancel: _vm.closeExportSettings },
            },
            [
              _c("ExportSettings", {
                attrs: { fields: _vm.fields, records: _vm.records },
                on: {
                  start: _vm.onExportSettingsStart,
                  cancel: _vm.closeExportSettings,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.exportInProgress
        ? _c("div", { staticClass: "export-progress-overlay" }, [
            _c(
              "div",
              { staticClass: "export-progress-card" },
              [
                _c("div", { staticClass: "title" }, [
                  _vm._v("Excel Dışa Aktarım"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "subtitle" }, [
                  _vm._v(
                    "Toplam " + _vm._s(_vm.exportProgress.total) + " kayıt"
                  ),
                ]),
                _vm._v(" "),
                _c("a-progress", {
                  attrs: {
                    percent: _vm.exportProgress.percent,
                    status: "active",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "detail" },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.exportProgress.fetched) +
                          " / " +
                          _vm._s(_vm.exportProgress.total)
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.exportInProgress
                      ? _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { size: "small" },
                            on: { click: _vm.cancelExport },
                          },
                          [_vm._v("İptal")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }